module.exports = __webpack_public_path__ + "img/iwaly-icon.b1c0b104.png";